//region block: pre-declaration
//endregion
function isTestRun() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0 = ['afterEach', 'after', 'beforeEach', 'before', 'describe', 'it'];
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlin.collections.all' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = globalThis[element];
      if (!(!(tmp == null) ? typeof tmp === 'function' : false)) {
        tmp$ret$4 = false;
        break $l$block;
      }
    }
    tmp$ret$4 = true;
  }
  return tmp$ret$4;
}
//region block: exports
export {
  isTestRun as isTestRun2hvu4ktvvkhb7,
};
//endregion

//# sourceMappingURL=IsTestRun.mjs.map
